import { render } from "./ProductsDetailView.vue?vue&type=template&id=9ef2736a&scoped=true"
import script from "./ProductsDetailView.vue?vue&type=script&lang=js"
export * from "./ProductsDetailView.vue?vue&type=script&lang=js"

import "./ProductsDetailView.vue?vue&type=style&index=0&id=9ef2736a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ef2736a"]])

export default __exports__